import { useRef } from 'react'
import { Link } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { styles } from './styles.css'
import logo from './images/logo.svg'
import menu from './images/menu.svg'

export const NavigationBar: React.FC = () => {
  const backdrop = useRef<HTMLDivElement>(null)
  const checkbox = useRef<HTMLInputElement>(null)

  const handleBackdropClick: React.MouseEventHandler<HTMLDivElement> = () => {
    if (checkbox.current) {
      checkbox.current.checked = false
    }
  }

  return (
    <nav className={styles.nav}>
      <div className={styles.backdrop} ref={backdrop} onClick={handleBackdropClick} />
      <Flex align="end" justify="center" className={styles.header}>
        <Flex align="center" justify="center" className={styles.headerContent}>
          <Link to="/subscription" className={styles.logo}>
            <img src={logo} alt="FLOWER" />
          </Link>
          <label htmlFor="nav-toggle" className={styles.navToggle}>
            <img src={menu} />
            <input type="checkbox" id="nav-toggle" hidden ref={checkbox} />
          </label>
        </Flex>
      </Flex>
      <div className={styles.navContent}>
        <Flex direction="column" align="start" className={styles.links}>
          <Link to="/subscription" className={styles.link}>
            FLOWERの定期便
          </Link>
          <a href="/subscription/mypage" className={styles.link}>
            マイページ
          </a>
          <a href="/faq" className={styles.link}>
            FAQ
          </a>
          <a href="/policy" className={styles.link}>
            プライバシーポリシー
          </a>
          <a href="/terms" className={styles.link}>
            利用規約
          </a>
          <a href="/commercial" className={styles.link}>
            特定商取引法に関する表記
          </a>
        </Flex>
      </div>
    </nav>
  )
}
